import { CommonModule } from '@angular/common';
import { NgModule, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TYTCommonModule } from '@tytapp/common';
import { CommonUiModule } from '@tytapp/common-ui';
import { ContentModule } from '@tytapp/content';
import { ContentBlocksService } from '@tytapp/content/content-blocks.service';
import { EMBED_BLOCK_TYPE } from './embed-block';
import { HEADING_BLOCK_TYPE } from './heading-block';
import { SECTION_TAG_BLOCK_TYPE } from './section-tag-block';
import { TEXT_BLOCK_TYPE } from './text-block';
import { YOUTUBE_BLOCK_TYPE } from './youtube-block';
import { TWEET_BLOCK_TYPE } from './tweet-block';
import { IMAGE_BLOCK_TYPE } from './image-block';
import { EditorCommonModule } from '@tytapp/editor-common';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { OFFER_SET_BLOCK_TYPE } from './offer-set-block';
import { ANCHOR_BLOCK_TYPE } from './anchor-block';
import { HERO_BLOCK_TYPE } from './hero-block';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TEASER_LIST_BLOCK_TYPE } from './teaser-list-block';
import { FEATURE_LIST_BLOCK_TYPE } from './feature-list-block';
import { HONOR_ROLL_BLOCK_TYPE } from './honor-roll-block';
import { CONTENT_VIEW_BLOCK_TYPE } from './content-view-block';
import { TAB_GROUP_BLOCK_TYPE } from './tab-group-block';
import { MatTabsModule } from '@angular/material/tabs';

const BLOCK_TYPES = [
    TEXT_BLOCK_TYPE,
    SECTION_TAG_BLOCK_TYPE,
    HEADING_BLOCK_TYPE,
    EMBED_BLOCK_TYPE,
    YOUTUBE_BLOCK_TYPE,
    TWEET_BLOCK_TYPE,
    IMAGE_BLOCK_TYPE,
    OFFER_SET_BLOCK_TYPE,
    ANCHOR_BLOCK_TYPE,
    HERO_BLOCK_TYPE,
    TEASER_LIST_BLOCK_TYPE,
    FEATURE_LIST_BLOCK_TYPE,
    HONOR_ROLL_BLOCK_TYPE,
    CONTENT_VIEW_BLOCK_TYPE,
    TAB_GROUP_BLOCK_TYPE
];

const DECLARATIONS = [
    TEXT_BLOCK_TYPE.viewComponent,
    TEXT_BLOCK_TYPE.editorComponent,
    SECTION_TAG_BLOCK_TYPE.viewComponent,
    SECTION_TAG_BLOCK_TYPE.editorComponent,
    HEADING_BLOCK_TYPE.viewComponent,
    HEADING_BLOCK_TYPE.editorComponent,
    EMBED_BLOCK_TYPE.viewComponent,
    EMBED_BLOCK_TYPE.editorComponent,
    YOUTUBE_BLOCK_TYPE.viewComponent,
    YOUTUBE_BLOCK_TYPE.editorComponent,
    TWEET_BLOCK_TYPE.viewComponent,
    TWEET_BLOCK_TYPE.editorComponent,
    IMAGE_BLOCK_TYPE.viewComponent,
    IMAGE_BLOCK_TYPE.editorComponent,
    OFFER_SET_BLOCK_TYPE.viewComponent,
    OFFER_SET_BLOCK_TYPE.editorComponent,
    ANCHOR_BLOCK_TYPE.viewComponent,
    ANCHOR_BLOCK_TYPE.editorComponent,
    HERO_BLOCK_TYPE.viewComponent,
    HERO_BLOCK_TYPE.editorComponent,
    TEASER_LIST_BLOCK_TYPE.viewComponent,
    TEASER_LIST_BLOCK_TYPE.editorComponent,
    FEATURE_LIST_BLOCK_TYPE.viewComponent,
    FEATURE_LIST_BLOCK_TYPE.editorComponent,
    HONOR_ROLL_BLOCK_TYPE.viewComponent,
    HONOR_ROLL_BLOCK_TYPE.editorComponent,
    CONTENT_VIEW_BLOCK_TYPE.viewComponent,
    CONTENT_VIEW_BLOCK_TYPE.editorComponent,
    TAB_GROUP_BLOCK_TYPE.viewComponent,
    TAB_GROUP_BLOCK_TYPE.editorComponent,
];

@NgModule({
    imports: [
        ContentModule,
        FormsModule,
        CommonModule,
        TYTCommonModule,
        CommonUiModule,

        /**
         * I didn't want to have to do this- effectively we are including EditorCommonModule in
         * the root bundle. Unfortunately it's not clear how to arrange things so that the editor
         * components for each component can be loaded lazily without completely separating the view
         * portion from the editor portion, which would require a more complex ContentBlocksService with
         * registration for both the block type and the editor portion.
         */
        EditorCommonModule,
        MatFormFieldModule,
        MatButtonModule,
        MatIconModule,
        MatSelectModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonToggleModule,
        MatTabsModule,
        DragDropModule
    ],
    declarations: DECLARATIONS,
    exports: DECLARATIONS
})
export class CoreContentBlocksModule {
    private blockTypes = inject(ContentBlocksService);

    constructor() {
        for (let type of BLOCK_TYPES)
            this.blockTypes.register(type);
    }
}